import {
  get,
  put,
  post
} from '@/service/configApi'

export async function fetchCompayList(body) {
  return await get(`/company/list/admin`, body)
}

export async function fetchCompanyById(body) {
  return await get(`/company/detail/admin/byid`, body)
}

export async function updateCompany(body) {
  //return await put(`/company/manage/update`, body)
  return await put(`/company/manage/update`, {
    id: body.id,
    domainName: body.domainName,
    title: body.title,
    description: body.description,
    logo: body.logo,
    appLogo: body.appLogo,
    coverImg: body.coverImg,
    headerColor: body.color.headerColor,
    buttonColor: body.color.buttonColor,
    footerColor: body.color.footerColor,
    themeColor: body.color.themeColor,
    keyIcon: body.keyIcon,
    systemEmail: body.systemEmail,
    contactEmail: body.contactEmail,
    externalAccess: body.externalAccess,
    permission: {
      isArticle: body.permission.isArticle,
      isBook: body.permission.isBook,
      isChatLivestream: body.permission.isChatLivestream,
      isCheckNameLivestream: body.permission.isCheckNameLivestream,
      isDocument: body.permission.isDocument,
      isExam: body.permission.isExam,
      isImage: body.permission.isImage,
      isImageLivestream: body.permission.isImageLivestream,
      isLivestream: body.permission.isLivestream,
      isOtherfile: body.permission.isOtherfile,
      isPdfLivestream: body.permission.isPdfLivestream,
      isQuizLivestream: body.permission.isQuizLivestream,
      isVideo: body.permission.isVideo,
      isVotePollLivestream: body.permission.isVotePollLivestream,
      isWebLivestream: body.permission.isWebLivestream,
      isWebsite: body.permission.isWebsite,
      isYoutube: body.permission.isYoutube,
      limitTeacher: body.permission.limitTeacher,
      limitUser: body.permission.limitUser,
      limitVideo: body.permission.limitVideo
    },
    canRegister: body.register.canRegister,
    loginEmail: body.register.loginEmail,
    loginGoogle: body.register.loginGoogle,
    loginAppleID: body.register.loginAppleID,
    loginFacebook: body.register.loginFacebook,
    courseLimit: body.course.courseLimit,
    storageLimit: body.storage.storageLimit,
    userLimit: body.user.userLimit,
    slugName: body.slugName,
    // comment omiseCustomerToken: null,
  })
}

export async function insertCompany(body) {
  return await post(`/company/manage/insert`, {
    title: body.title,
    systemEmail: body.systemEmail,
    domainName: body.domainName,
  })
}
export async function insertCompanyAndInsertMenu(body) {
  return await post(`/company/manage/createbysuperadmin`, {
    title: body.title,
    systemEmail: body.systemEmail,
    domainName: body.domainName,
  })
}
export async function activeCompany(body) {
  return await put(`/company/manage/active`, {
    id: body.id,
    active: body.active,
  })
}
export async function updateCompanyAdCom(body) {
  return await put(`/company/manage/updatecompanybyuser`, body)
}
export async function updateConnectTool(body) {
  return await put(`/company/manage/update/connecttoolswith`, body)
}
